import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordService } from './reset-password.service';
import Swal from 'sweetalert2';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [TranslateModule, CommonModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {

  fieldTextType: boolean = false;
  submitted = false;
  token: string = '';
  getUserDetails: any[] = [];
  usernames: string = 'all';
  resetPasswordForm = new FormGroup({
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    passwordConfirmation: new FormControl('', [Validators.required]),
    username: new FormControl(''),
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public toaster: ToastrService,
    private resetPasswordService: ResetPasswordService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // Extract token from the URL
    this.token = this.route.snapshot.params['token'];
    if (!this.token) {
      Swal.fire({
        icon: 'error',
        title: this.translateService.instant('Error!'),
        text: this.translateService.instant('Invalid reset password link.'),
        confirmButtonText: this.translateService.instant('OK'),
      }).then(() => {
        this.router.navigate(['/login']);
      });
      return;
    }

    // Fetch username using the token
    const lang = localStorage.getItem('locale') ?? 'en';
    this.resetPasswordService.getUsernameByToken(this.token, lang).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.getUserDetails = res.data;
        } else {
          this.toaster.error(this.translateService.instant('Your link has been expired'));
        }
      },
      error: (err) => {
        //get error
      },
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  onSubmit() {
    if (this.resetPasswordForm.invalid) {
      return;
    }

    const password = this.resetPasswordForm.value.password!;
    const passwordConfirmation = this.resetPasswordForm.value.passwordConfirmation!;
    const lang = localStorage.getItem('locale') ?? 'de';

    if (this.getUserDetails?.length > 1) {
      this.usernames = this.resetPasswordForm.value.username ?? 'all';
    } else {
      this.usernames = 'all';
    }

    if (password !== passwordConfirmation) {
      Swal.fire({
        icon: 'error',
        title: this.translateService.instant('Error!'),
        text: this.translateService.instant('Passwords do not match.'),
        confirmButtonText: this.translateService.instant('OK'),
      });
      return;
    }

    this.submitted = true;
    this.resetPasswordService
      .resetPassword(this.token, password, passwordConfirmation, this.usernames, lang)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            Swal.fire({
              icon: 'success',
              title: this.translateService.instant('Success!'),
              text: this.translateService.instant('Your password has been reset successfully.'),
              confirmButtonText: this.translateService.instant('OK'),
            }).then(() => {
              this.router.navigate(['/login']);
            });
          } else {
            this.submitted = false;
            Swal.fire({
              icon: 'error',
              title: this.translateService.instant('Error!'),
              text: res.message,
              confirmButtonText: this.translateService.instant('OK'),
            });
          }
        },
        error: (err) => {
          this.submitted = false;
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant('Error!'),
            text: this.translateService.instant('An error occurred while resetting your password. Please try again.'),
            confirmButtonText: this.translateService.instant('OK'),
          });
        },
      });
  }




}
